import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { acGetAllCreditPolicies, acActivateCreditPolicy } from '../../store/actions'
import { ERRORS } from '../../store/constants'
import { ConfirmModal, Snackbar } from '../default'

/**
 * @description Renders a modal component for activating or desactivating a credit policy.
 * 
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines if the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @param {object} selectedCreditPolicy - The selected credit policy object.
 * @returns {JSX.Element} The rendered modal component.
 */
const ActivateCreditPolicyModal = ({ open, onClose, selectedCreditPolicy }) => {

    const dispatch = useDispatch()

    const [snackbarData, setSnackbarData] = useState({ open: false, severity: 'success', message: '' })

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setSnackbarData({ ...snackbarData, open: false })
    }

    const onConfirm = () => {
        if (selectedCreditPolicy?.is_active) {
            onClose()
        } else {
            dispatch(acActivateCreditPolicy(selectedCreditPolicy.credit_policy_id))
                .then(() => {
                    onClose()
                    setSnackbarData({ open: true, severity: 'success', message: `Política de crédito #${selectedCreditPolicy.credit_policy_id} ${selectedCreditPolicy.is_active ? 'desativada' : 'ativada'} com sucesso!` })
                    dispatch(acGetAllCreditPolicies())
                        .catch(error => console.error(error))
                })
                .catch(err => {
                    console.error(err)
                    onClose()
                    setSnackbarData({ open: true, severity: 'error', message: `Não foi possível alterar a política de crédito #${selectedCreditPolicy.credit_policy_id}. ${ERRORS[err.description]}` })
                })
        }
    }

    return (
        <>
            <ConfirmModal
                open={open} onClose={onClose} onConfirm={onConfirm}
                title={selectedCreditPolicy?.is_active ? 'Desativar Política de Crédito' : 'Ativar Política de Crédito'}
                id={selectedCreditPolicy?.credit_policy_id}
                description={
                    selectedCreditPolicy?.is_active
                        ? `Você deve ativar outra política de crédito para que a política de crédito #${selectedCreditPolicy?.credit_policy_id} seja desativada.`
                        : `Você tem certeza que deseja ativar a política de crédito #${selectedCreditPolicy?.credit_policy_id} ?`
                }
                confirmText={selectedCreditPolicy?.is_active ? 'OK' : 'Confirmar'}
                showCancelText={selectedCreditPolicy?.is_active ? false : true}
            />
            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                message={snackbarData.message}
                severity={snackbarData.severity}
            />
        </>
    )

}

ActivateCreditPolicyModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedCreditPolicy: PropTypes.object
}

export default ActivateCreditPolicyModal